import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct/publishEvent/message'

export default ($axios) => ({

  /**
   * This is just the first draft of event publishing, @TODO is just a message for now
   * but should be changed into an object when requirements grow
   */
  publishEvent(event) {
    return $axios.post(`${resource}`, event)
  }

})
